import { render, staticRenderFns } from "./myOutofOffice.vue?vue&type=template&id=2d20ce38&"
import script from "./myOutofOffice.vue?vue&type=script&lang=js&"
export * from "./myOutofOffice.vue?vue&type=script&lang=js&"
import style0 from "./myOutofOffice.vue?vue&type=style&index=0&id=2d20ce38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports